// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@steiner/App/SharedStyles/CartLineSharedStyles";
import { cartLineNotesStyles } from "@steiner/Overrides/Widgets/Cart/CartLineNotes";
import { hideElementOnPrint } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartLineNotesStyles.wrapper = {
    ...cartLineSharedStyles.cartLineNotes?.wrapper,
};

cartLineNotesStyles.editableNotesTextArea = {
    ...cartLineSharedStyles.cartLineNotes?.editableNotesTextArea,
    css: css`
        ${hideElementOnPrint}
    `,
};

cartLineNotesStyles.linksWrapper = {
    ...cartLineSharedStyles.cartLineNotes?.linksWrapper,
};

cartLineNotesStyles.showHideLink = {
    ...cartLineSharedStyles.cartLineNotes?.showHideLink,
};

cartLineNotesStyles.addToProjectsLink = {
    ...cartLineSharedStyles.cartLineNotes?.addToProjectsLink,
};

cartLineNotesStyles.readOnlyNotesText = {
    css: css`
        display: none;

        @media print {
            display: block;
        }
    `,
};
